'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export default function RouteChangeListener() {
  const pathname = usePathname();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const rum = window.__pranaClubRum;
    if (!rum || !pathname) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    rum.recordPageView({
      pageId: pathname,
      pageAttributes: {
        routeSource: 'route-change',
      },
    });

    console.info('RUM recordPageView', { pageId: pathname });
  }, [pathname]);

  return null;
}
